
const clientHomepage = (
    <div className="client-homepage">
        <h2>Welcome to the Dentifier tool!</h2>

        <div>
            <p>Here are some instructions on how to use this tool:</p>
            <ol>
                <li>Go to the <a href="/predict">Predict Page</a>.</li>
                <li>Upload your photo.</li>
                <li>Review the uploaded photo.</li>
                <li>Wait for an email with the confirmation of the length and type.</li>
            </ol>
        </div>
        <p>
            If you have any questions, you can ask them to the chatbot in the bottom right corner.
        </p>
    </div>
);

export default clientHomepage;